var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCraneConstructionGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.11 112.5H37.47V132.52H101.11V112.5Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.56,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.48 86.47H119.8V91.81H136.48V86.47Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.74,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6499 73.6899H2.62988V112.31H22.6499V73.6899Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.56,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.16 39.76H52.4099L72.7599 29.22L137.16 39.76Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.56,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.64 112.29H127.27V132.66H147.64V112.29Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.56,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8699 74.0799V34.2399L35.8799 20.8999V92.5499",
    stroke: "#1F323D",
    strokeWidth: 0.74,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.21 28.97V34.62",
    stroke: "#1F323D",
    strokeWidth: 0.74,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.21 48.99V54.64",
    stroke: "#1F323D",
    strokeWidth: 0.74,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.21 38.98V44.63",
    stroke: "#1F323D",
    strokeWidth: 0.74,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127.48 36.4299V86.4799",
    stroke: "#1F323D",
    strokeWidth: 0.74,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0798 28.4199V112.5",
    stroke: "#1F323D",
    strokeWidth: 0.74,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6699 29.0898V112.5",
    stroke: "#1F323D",
    strokeWidth: 0.74,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2598 111.87L79.3998 87.82L68.2598 63.77",
    stroke: "#1F323D",
    strokeWidth: 0.74,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4899 63.9299L68.3499 87.9899L79.4899 112.04",
    stroke: "#1F323D",
    strokeWidth: 0.74,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3899 63.5898L79.5299 39.5398",
    stroke: "#1F323D",
    strokeWidth: 0.74,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M68.23 39.6599L79.37 63.7199",
    stroke: "#1F323D",
    strokeWidth: 0.74,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M111.96 131.85H54.3899",
    stroke: "#1F323D",
    strokeWidth: 0.74,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1598 116.5H41.5098",
    stroke: "#1F323D",
    strokeWidth: 0.74,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1698 116.5H51.5198",
    stroke: "#1F323D",
    strokeWidth: 0.74,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCraneConstructionGrey);
export default __webpack_public_path__ + "static/media/crane_construction_grey.e61caa8035050301a96682f052840b61.svg";
export { ForwardRef as ReactComponent };